//import Vue from 'vue'
import { createApp } from 'vue'

import { vMaska } from "maska"

import StoreMain from './store/index.js';


import { createRouter, createWebHistory } from 'vue-router'
import { createStore } from 'vuex'
import axios from 'axios';
import { Vuelidate } from '@vuelidate/core'

import App from './App.vue'
import Main from './views/Main.vue'

import Catalog from './views/Catalog.vue'
import Auth from './views/Auth.vue'
import Basket from './views/Basket.vue'
import OrderCreate from './views/OrderCreate.vue'
import Orders from './views/Orders.vue'
import OrderDetail from './views/OrderDetail.vue'


const instance = axios.create({
    baseURL: '/api/v1',
    timeout: 120000,
    withCredentials: true,
    headers: {
        'Content-Type' : 'application/x-www-form-urlencoded',
    }
});

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    instance.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}



instance.interceptors.response.use(
    function (response) {
        if(response.data.errors)
            response.data.errors.forEach(function(error) {
                console.log(error);
            });
        return response;
    },
    function(err) {

        if(err == "Error: Network Error"){alert("Проверте соединение с интернетом и перезайдите в приложение через некоторое время.");}


        if(err.response.status === 401) {}
        //TODO:Если истекла сессия обновить сайт

        //TODO:Доделать обновление токена
        if(err.response.status === 403 && err.response.data.error == 'Invalid CSRF Token' && error.data.csrf) {
            return axios(response.config);
        }
        return Promise.reject(err);
    }
);


const routes = [
    {
        path: '/',
        component: Main,
        children: [
            {
                path: '/',
                beforeEnter:  (to, from, next) => {
                    next("/catalog");
                },
            },
            {
                path: '/catalog',
                name:'Каталог',
                component: Catalog,
                beforeEnter:  (to, from, next) => {
                    next();
                },
            },
            {
                path: '/orders',
                name:'Заказы',
                component: Orders,
                beforeEnter: (to, from, next) => {
                    next();
                },
            },
            {
                path: '/basket',
                name:'Корзина',
                component: Basket,
                beforeEnter:  (to, from, next) => {
                    next();
                },
            },
            {
                path: '/order/:id',
                name:'Детальная заказа',
                props: true,
                component: OrderDetail,
                beforeEnter:  (to, from, next) => {
                    next();
                },
            },
        ]
    },

    {
        path: '/order_create/:id',
        name:'Оформление заказа',
        component: OrderCreate,
        props: true,
        beforeEnter:  (to, from, next) => {
            next();
        },
    },
    {
        path: '/auth',
        name:'Авторизация',
        component: Auth,
        beforeEnter: (to, from, next) => {
            next();
        },
    },

];

const router = createRouter({
    history: createWebHistory(),
    routes,
});



let $app =  createApp(App, {instance: instance}).use(router).use(StoreMain).directive("maska", vMaska);

$app.mount('#app');





